<template>
  <div class="keep-alive">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!--不缓存的视图-->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <template></template>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
export default {
  data() {
    return {
      list: [
        {
          name: '逐日消耗登记表',
          url: '/fire/foodModuleIndex/purchaseIndex/printIndex/printDailyConsumption'
        },
        {
          name: '一周伙食采购报表',
          url: '/fire/foodModuleIndex/purchaseIndex/printIndex/printFoodAccount'
        },
        {
          name: '采购代发票',
          url: '/fire/foodModuleIndex/purchaseIndex/printIndex/printSubstituteInvoice'
        }
      ],
      timerId: null
    }
  },
  mounted() {
    config()
    this.timerId = setTimeout(() => {
      this.$bus.emit('isShowTopMenu', true)
      this.$bus.emit('getTopMenuList', this.list)
    })
  },
  beforeDestroy () {
    clearTimeout(this.timerId)
  }
};
</script>
<style lang='scss' scoped>
.keep-alive {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>